import { request } from './request';

export interface ICrystalOnboardingConfig {
  network: {
    mode: "auto" | "device" | "custom";
    device?: string;
    portMap?: { wan: string[]; lan: string[] };
  };
}

export interface ICrystalLicense {
  license_id: string;
  status: "available" | "bound" | "configured" | "iso_ready" | "activated";
  license_type: string | null;
  msp_id: string | null;
  onboarding_config: ICrystalOnboardingConfig | null;
  bound_ts: number;
}

const postJSON = (body: object): RequestInit => ({
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(body),
});

export const fetchCrystalLicenses = (): Promise<{ licenses: ICrystalLicense[] }> =>
  request('/crystal/licenses', postJSON({}));
